import React from 'react';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';

import routes from '../../constants/routes';
import Error from '../Pages/Error';
import Home from 'components/Pages/Home';
import Fives from 'components/Pages/Fives';
import Bonus from 'components/Pages/Bonus';
import BonusDetails from 'components/Pages/BonusDetails';
import DecisionTime from 'components/Pages/DecisionTime';
import Widget from 'components/Pages/Widget';
import NavBar from 'components/NavBar';
import config from 'theme/config';

export default function Routes(): React.ReactElement<BrowserRouter> {
  return (
    <BrowserRouter>
      <NavBar />
      <Switch>
        <Route exact path={routes.HOME.route} component={Home} />
        <Route exact path={routes.FIVES.route} component={Fives} />
        {config.settings.bonusEnabled && <Route exact path={routes.BONUS.route} component={Bonus} />}
        {config.settings.bonusEnabled && <Route exact path={routes.BONUS_DETAILS.route} component={BonusDetails} />}
        {config.settings.bonusEnabled && <Route exact path={routes.DECISION_TIME.route} component={DecisionTime} />}
        {config.settings.widgetEnabled && <Route path={routes.WIDGET.route} component={Widget} />}
        {/* ToDo - remove me- Temp redirect fix for livescore UK */}
        <Redirect from="/uk" to="/" />
        <Route path="*" component={Error} />
      </Switch>
    </BrowserRouter>
  );
}
